/**
 * Created by mykurisu on 2018/4/16.
 */
import React from 'react'


class NoneItem extends React.Component {

    static defaultProps = {
        btnText: '',
        btnMethod: null,
        text: '',
        img: '',
        btnType: 'default' // default: 绿底白字 | primary: 白底绿字
    };

    constructor() {
        super()
        this.state = {
            text: []
        }
    }

    componentDidMount() {
        if (/__br/.test(this.props.text)) {
            let a = this.props.text
            let list = a.split('__br')
            this.setState({
                text: list
            })
        } else {
            this.setState({
                text: [this.props.text]
            })
        }
    }

    render() {
        return (
            <div className={`details-none-item  ${this.props.isFixed ? "details-none-item__fixed" : ""}`}>
                <div className="item__img">
                    <img src={this.props.img} alt=""/>
                </div>
                <div className="item__text">
                    {this.state.text.map((item, index) => <div className="text__line" key={index+'text'}>{item}</div>)}
                </div>
                {this.props.btnText && this.props.btnMethod &&
                <div className={this.props.btnType === 'primary' ? "item__btn__primary" : "item__btn"} onClick={() => this.props.btnMethod()}>
                    {this.props.btnText}
                </div>
                }
            </div>
        )
    }
}

export default NoneItem



// WEBPACK FOOTER //
// ./src/components/details/NoneItem.js